import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`The "`}<strong parentName="p">{`developers`}</strong>{`" team is automatically created when you create an organization. By default, the developers team has read/write access to all new packages created under the organization's scope.`}</p>
    <ul>
      <li parentName="ul">{`Members added to the organization, including the organization owner, are automatically added to the `}<strong parentName="li">{`developers`}</strong>{` team`}</li>
      <li parentName="ul">{`The `}<a parentName="li" {...{
          "href": "/files/package.json#people-fields-author-contributors"
        }}><inlineCode parentName="a">{`maintainers`}</inlineCode>{` field`}</a>{` in the `}<a parentName="li" {...{
          "href": "/files/package.json"
        }}><inlineCode parentName="a">{`package.json`}</inlineCode></a>{` of any newly created packages under the organization scope
is automatically populated with the members of the current `}<strong parentName="li">{`developers`}</strong>{` team`}</li>
    </ul>
    <p>{`If you create a new package under your organization's scope and you do not
want members of the `}<strong parentName="p">{`developers`}</strong>{` team to have read/write access to that
package, an owner or admin can remove the `}<strong parentName="p">{`developers`}</strong>{` team's access to that
package. For more informations, see "`}<a parentName="p" {...{
        "href": "managing-team-access-to-org-packages"
      }}>{`Managing team access to organization packages`}</a>{`".`}</p>
    <p>{`If an owner adds a new member to an organization and `}<strong parentName="p">{`does not`}</strong>{` want
that member to be on the `}<strong parentName="p">{`developers`}</strong>{` team, an owner can remove them.`}</p>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` The `}<strong parentName="p">{`developers`}</strong>{` team can no longer be removed from an organization for the following reasons:`}</p>
      <ul>
        <li parentName="ul">{`It is the source of truth for all users, packages, and default permissions in an organization.`}</li>
        <li parentName="ul">{`When you want to restrict write access, it is almost always better to set the default permissions to read-only and create separate teams for managing write permissions.`}</li>
      </ul>
    </Note>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      